module.exports = __webpack_public_path__ + "static/my-lista-b124aca26f9eaa51db9e45c69578a1ef.png";